import styled from "styled-components";

const TIMEOUT = 300;

const Fade = `
  opacity: 0;

  &.fade {
    transition: opacity ${TIMEOUT}ms;
  }
  &.fade-enter {
    opacity: 0;
  }
  &.fade-enter-active {
    opacity: 1;
  }
  &.fade-enter-done {
    opacity: 1;
  }
  &.fade-exit {
    opacity: 1;
  }
  &.fade-exit-active {
    opacity: 0;
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1000;

  ${Fade}
`;

export const Content = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  pointer-events: none;

  ${Fade}
`;

export const ImageWrapper = styled.div`
  pointer-events: auto;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  display: block;
  user-select: none;
`;

const iconButton = `
  pointer-events: auto;
  z-index: 1;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  line-height: 1;
  transition: background 150ms;

  &:hover,
  &:focus-visible {
    background: rgba(0, 0, 0, 0.85);
    outline: 2px solid white;
    outline-offset: 2px;
  }
`;

export const CloseButton = styled.button`
  ${iconButton}
  position: absolute;
  top: 5rem;
  right: 1rem;
`;

export const PrevButton = styled.button`
  ${iconButton}
  position: absolute;
  left: 5rem;
  top: 50%;
  transform: translateY(-50%);

  @media (max-width: ${({ theme }) => theme.grid.breakpoints.md}) {
    left: 1rem;
  }
`;

export const NextButton = styled.button`
  ${iconButton}
  position: absolute;
  right: 5rem;
  top: 50%;
  transform: translateY(-50%);

  @media (max-width: ${({ theme }) => theme.grid.breakpoints.md}) {
    right: 1rem;
  }
`;

export const VideoPlayer = styled.video`
  max-width: 90vw;
  max-height: 90vh;
  display: block;
  outline: none;
`;

export const Counter = styled.div`
  pointer-events: auto;
  position: absolute;
  top: 1.2rem;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.6);
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
`;
